export default "__VITE_ASSET__DcZF541K__"